
import { getAPIBankingClient, getAPIClient } from "./Axios";
import { getN8N } from "./AxiosN8N";
import { getTaxV2 } from "./AxiosTaxV2";

export const api = getAPIClient();
export const api_banking = getAPIBankingClient();
export const apiTaxesv2 = getTaxV2();
export const apiN8N = getN8N();
